/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function () {
  var modal = null;
  var lastTrigger = null;

  function ensureModal() {
    if (modal) {
      return modal;
    }

    modal = document.createElement('div');
    modal.id = 'not-for-sale-modal';
    modal.className = 'NotForSaleModal';
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = [
      '<div class="NotForSaleModal__Overlay" data-not-for-sale-close></div>',
      '<div class="NotForSaleModal__Dialog" role="dialog" aria-modal="true" aria-labelledby="NotForSaleModalTitle">',
      '  <button type="button" class="NotForSaleModal__Close" data-not-for-sale-close aria-label="Close">&times;</button>',
      '  <p id="NotForSaleModalTitle" class="NotForSaleModal__Title Heading u-h3">NOT FOR SALE</p>',
      '  <p class="NotForSaleModal__Text">This friends and family item is not for sale.</p>',
      '  <button type="button" class="Button Button--primary NotForSaleModal__Button" data-not-for-sale-close>Close</button>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);

    return modal;
  }

  function openModal(trigger) {
    var instance = ensureModal();
    lastTrigger = trigger || null;

    instance.setAttribute('aria-hidden', 'false');
    document.body.classList.add('NotForSaleModal--open');

    var closeButton = instance.querySelector('.NotForSaleModal__Button');

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeModal() {
    if (!modal) {
      return;
    }

    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('NotForSaleModal--open');

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-not-for-sale-trigger]');

    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    var closeTarget = event.target.closest('[data-not-for-sale-close]');

    if (closeTarget) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    var trigger = event.target.closest('[data-not-for-sale-trigger]');

    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (event.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
})();
